import React from 'react';
import { Box, Typography } from '@mui/material';
import Benefit1Svg from '../images/benefit1.svg';
import Benefit2Svg from '../images/benefit2.svg';
import Benefit3Svg from '../images/benefit3.svg';
import Benefit4Svg from '../images/benefit4.svg';
import Benefit5Svg from '../images/benefit5.svg';
import Benefit6Svg from '../images/benefit6.svg';
import BenefitCard from './BenefitCard';
import Benefits from './style';

const benefitsData = [
    {
        icon: Benefit1Svg,
        title: 'Developer\nProductivity',
    },
    {
        icon: Benefit2Svg,
        title: 'Faster\nProvisioning',
    },
    {
        icon: Benefit3Svg,
        title: 'End to End\nAutomation',
    },
    {
        icon: Benefit4Svg,
        title: 'Security &\nGovernance',
    },
    {
        icon: Benefit5Svg,
        title: 'Simplified User Experience',
    },
    {
        icon: Benefit6Svg,
        title: 'Improved Utilization & Productivity',
    },
];

function BenefitsSection() {
    return (
        <Box component="section" sx={Benefits.BenefitsSection.section}>
            <Box sx={Benefits.BenefitsSection.container}>
                <Box sx={Benefits.BenefitsSection.textContainer}>
                    <Typography component="h2" sx={Benefits.BenefitsSection.heading}>
                        Driving Benefits for Key Roles Within PepsiCo
                    </Typography>
                    <Typography sx={Benefits.BenefitsSection.subheading}>
                        Our expertise supports customers across the next
                        <br />
                        generation of technologies
                    </Typography>
                </Box>
                <Box sx={Benefits.BenefitsSection.cardsContainer}>
                    {benefitsData.map((benefit, index) => (
                        <BenefitCard key={index} icon={benefit.icon} title={benefit.title} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default BenefitsSection;
